import { memo } from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { PageContainer } from '@/components/templates/PageContainer';
import { PageHeaderSkeleton, NotificationRowSkeleton } from '@/components/molecules/skeletons';
import { SKELETON } from '@/lib/constants';

const RightSidebarSkeleton = (
  <div className="sticky top-20 w-40 h-[600px]">
    <Skeleton className="h-full w-full rounded-xl" />
  </div>
);

export const NotificationsPageSkeleton = memo(() => {
  return (
    <PageContainer rightSidebar={RightSidebarSkeleton}>
      <div className="space-y-6">
        <PageHeaderSkeleton />
        <div className="bg-card border border-border rounded-xl shadow-none divide-y divide-border">
          {Array.from({ length: SKELETON.NOTIFICATION_ROWS }, (_, i) => (
            <NotificationRowSkeleton key={i} variant="page" />
          ))}
        </div>
      </div>
    </PageContainer>
  );
});

NotificationsPageSkeleton.displayName = 'NotificationsPageSkeleton';
